import React from "react";
import { BiArrowBack } from "react-icons/bi";
import SignedInNavbarImproved from "../../SignedInNavbarImproved";
import SuccessVoucherCardImage from "../../../assets/successVoucherCardImage.svg";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

function CreateVoucherBulkSuccess() {
  let navigate = useNavigate();
  // const { userNextAction } = useSelector((state) => state.modal);

  const handleRedirect = () => {
    navigate("/list-of-vouchers");
  };
  return (
    <div>
      <SignedInNavbarImproved />
      <div className="mx-auto mt-10 max-w-[1600px] px-3 pb-40 xsm:px-6 sm:px-8 md:px-12 lg:px-14">
        <div className="mt-4 flex items-center space-x-2 sm:space-x-4">
          <div
            onClick={() => navigate(-1)}
            className="rounded-full p-1 hover:bg-gray-200"
          >
            <BiArrowBack className="h-6 w-6 cursor-pointer text-gray-600" />
          </div>
          <h1 className="text-lg font-bold text-gray-700 sm:text-2xl">
            Bulk Voucher Created
          </h1>
        </div>
        <div className="mt-10 flex flex-col items-center justify-center text-center">
          <div className="rounded-md border-[0.5px] border-gray-200 px-20 py-10 shadow-lg">
            <div className="flex justify-center">
              <img
                src={SuccessVoucherCardImage}
                alt="success-img"
                className="h-20 w-auto"
              />
            </div>
            <p className="mt-2 text-center text-sm text-gray-500">
              Bulk Vouchers Successfully Created
            </p>
          </div>
          <h2 className="mt-6 text-xl font-bold text-gray-700">
            Assign/Share Gift Voucher
          </h2>
          <p className="max-w-lg text-sm text-gray-600">
            Assign vouchers Individually or Import User list via Excel or CSV
          </p>
          <div className="mt-6">
            <button
              onClick={(e) => {
                e.preventDefault();

                handleRedirect();
              }}
              className="transform cursor-pointer rounded-md bg-olivine-500 px-16 py-3 text-sm font-semibold text-white transition-all duration-200 hover:bg-olivine-400 focus:outline-none focus:ring-[2px] focus:ring-olivine-500 focus:ring-opacity-60 focus:ring-offset-1 active:bg-olivine-600"
            >
              Assign and Share Voucher
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CreateVoucherBulkSuccess;
